import { Navigate } from "react-router-dom";

export default function HomeRedirect() {
  const isMobile = window.innerWidth < 768;

  return isMobile ? (
    <Navigate to="/m-home" replace />
  ) : (
    <Navigate to="/dashboard" replace />
  );
}